import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function ObligationGroupSelect(props) {
  const {
    value,
    onHandleChange,
    className = "mb-2",
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
    isClearable = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [obligationGroups, setObligationGroups] = useState();

  // > LOAD OBLIGATION GROUPS //
  const loadObligationGroups = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            plantHex
              ? "api_r_user_module_legalCompliance_evaluation_getObligationGroups"
              : "api_r_user_module_globalLegalCompliance_evaluation_getObligationGroups"
          ),
          { moduleBridgeHex, plantHex }
        )
        .then((r) => {
          if (isMounted.current) {
            setObligationGroups(r.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, plantHex]
  );

  useEffect(() => {
    loadObligationGroups();
  }, []);
  // < LOAD OBLIGATION GROUPS //

  return (
    <AppMultiSelect
      options={obligationGroups}
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="obligation.groups" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select.one.or.multiple.obligation.groups"
        />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="price-tag-3" />}
      isLoading={!obligationGroups}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
    />
  );
}
